(function () {
    'use strict';

    if (typeof window === 'undefined') {
        utils(
            module.exports,
            require('lodash'),
            require('../../enums/benchmarkCompaniesFilters.js')
        );

    } else {
        utils(
            RivalIQ.module('utils.sort'),
            window._,
            RivalIQ.utils.benchmarkCompareAgainstOptions
        );
    }

    function utils(exports, _, benchmarkCompareAgainstOptions) {

        exports.default = function (valueA, valueB, sortOrder) {

            if (valueA === valueB) {
                return 0;
            }

            if (_.isString(valueB)) {
                return sortOrder * valueB.localeCompare(valueA);
            }

            // Handle NaNs, nulls, etc
            if (!_.isNumber(valueA)) {
                return sortOrder;
            }

            if (!_.isNumber(valueB)) {
                return sortOrder * -1;
            }

            return sortOrder * (valueB - valueA);
        };

        /*
         * We sort text blocks by length
         */
        exports.text = function (valueA, valueB, sortOrder) {
            return exports.default((valueA ? valueA.length : valueA), (valueB ? valueB.length : valueB), sortOrder);
        };

        function getCompanyColumnName(companyId) {
            const landscape = RivalIQ.state.landscape;

            const company = landscape.getCompanyById(companyId);
            if (company) {
                return company.get('name');
            } else {
                const benchmarkCompareAgainst = _.find(benchmarkCompareAgainstOptions, {
                    id: companyId
                });

                if (benchmarkCompareAgainst) {
                    return benchmarkCompareAgainst.name;
                }
            }

            return '';
        }

        exports.company = function (companyIdA, companyIdB, order) {
            const nameA = getCompanyColumnName(companyIdA);
            const nameB = getCompanyColumnName(companyIdB);

            return exports.default(nameA, nameB, order);
        };
    }
})();
